// PasswordResetConfirm.jsx
import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import SpinnerOverlay from "../components/spinnerOverlay/SpinnerOverlay";
import "./PasswordResetConfirm.css";
import api from "../utils/api";

const PasswordResetConfirmPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const isPasswordValid = (pass) => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(pass);
    const hasLowerCase = /[a-z]/.test(pass);
    const hasNumber = /\d/.test(pass);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(pass);
    return (
      pass.length >= minLength &&
      hasUpperCase &&
      hasLowerCase &&
      hasNumber &&
      hasSpecialChar
    );
  };

  const validateForm = () => {
    let tempErrors = {};
    // if (!code.trim()) tempErrors.code = 'Code is required';
    if (!newPassword) {
      tempErrors.newPassword = "New password is required";
    } else if (!isPasswordValid(newPassword)) {
      tempErrors.newPassword = "Password must meet all criteria";
    }
    if (!confirmPassword) {
      tempErrors.confirmPassword = "Confirm password is required";
    } else if (newPassword !== confirmPassword) {
      tempErrors.confirmPassword = "Passwords do not match";
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  // Password criteria check
  const getCriteriaColor = (criterionMet) =>
    criterionMet ? "green" : newPassword ? "red" : "#f0f0f0";
  const minLengthMet = newPassword.length >= 8;
  const upperCaseMet = /[A-Z]/.test(newPassword);
  const lowerCaseMet = /[a-z]/.test(newPassword);
  const numberMet = /\d/.test(newPassword);
  const specialCharMet = /[!@#$%^&*(),.?":{}|<>]/.test(newPassword);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      // setIsLoading(true);
      // setTimeout(() => {
      //   setIsLoading(false);
      //   console.log('Password reset:', { newPassword });
      // }, 2000);
      setIsLoading(true);
      try {
        await api.post("/users/reset-password", { token, newPassword });
        setSuccess(true);
        setTimeout(() => navigate("/login"), 3000);
      } catch (err) {
        setErrors({ submit: err.response?.data?.message || "Reset failed" });
      } finally {
        setIsLoading(false);
      }
    }
  };

  if (success) {
    return (
      <div className="confirm-container">
        <h1>Password Reset Successful!</h1>
        <p>Redirecting to login...</p>
      </div>
    );
  }

  return (
    <div className="confirm-container">
      {isLoading && <SpinnerOverlay />}
      <div className="logo-container">
        <img
          src="../images/tutors-logo.png"
          alt="Website Logo"
          className="confirm-logo"
        />
      </div>
      <div className="confirm-form-container">
        <h1 className="confirm-title">Set New password</h1>
        <p className="confirm-subtitle">
          Enter a new password you can remember
        </p>
        <form onSubmit={handleSubmit}>
          <div className="confirm-form-group">
            <label>New Password</label>
            <div className="password-container">
              <input
                type={showNewPassword ? "text" : "password"}
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="input-field"
              />
              <button
                type="button"
                onClick={() => setShowNewPassword(!showNewPassword)}
                className="toggle-password"
              >
                <span className="eye-icon">👁️</span>
              </button>
            </div>
            <div className="validation-row">
              <span
                className="validation-circle"
                style={{ backgroundColor: getCriteriaColor(specialCharMet) }}
              >
                One Special Character
              </span>
              <span
                className="validation-circle"
                style={{ backgroundColor: getCriteriaColor(numberMet) }}
              >
                One Number
              </span>
              <span
                className="validation-circle"
                style={{ backgroundColor: getCriteriaColor(upperCaseMet) }}
              >
                One Uppercase character
              </span>
              <span
                className="validation-circle"
                style={{ backgroundColor: getCriteriaColor(minLengthMet) }}
              >
                8 Character Min
              </span>

              <span
                className="validation-circle"
                style={{ backgroundColor: getCriteriaColor(lowerCaseMet) }}
              >
                One Lowercase character
              </span>
            </div>
            {errors.newPassword && (
              <p className="error">{errors.newPassword}</p>
            )}
          </div>
          <div className="confirm-form-group">
            <label>Confirm Password</label>
            <div className="password-container">
              <input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="input-field"
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="toggle-password"
              >
                <span className="eye-icon">👁️</span>
              </button>
            </div>
            {errors.confirmPassword && (
              <p className="error">{errors.confirmPassword}</p>
            )}
          </div>
          <button type="submit" className="create-account-btn">
            Reset Password <span className="arrow">→</span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default PasswordResetConfirmPage;
